import type { ExtensionFormulaRefFragment } from "../client/generated";
import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { RefNode } from "./RefNode";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    formulaRef: {
      setFormulaRef: (regionId: string) => ReturnType;
    };
  }
}

type FormulaRefOptions = {
  fragment: ExtensionFormulaRefFragment;
};

export const FormulaRef = Node.create<FormulaRefOptions, undefined>({
  name: "formulaRef",
  priority: 101,
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      regionId: {
        default: null,
        parseHTML: (element) => {
          const href = element.getAttribute("href");
          if (!href) return null;

          const regionId = new URL(href).hostname;
          return regionId;
        },
        renderHTML: (attributes) => {
          const href = `acdc://${attributes.regionId}`;
          return { href };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "formula-ref[href^='acdc://']",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["formula-ref", HTMLAttributes];
  },

  addCommands() {
    return {
      setFormulaRef:
        (regionId) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { regionId },
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(RefNode);
  },
});
